import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import {inject} from "@angular/core";
import {map} from "rxjs/operators";
import {UserDataService} from "./security/user-data.service";

export const appGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router: Router = inject(Router);
  const urlTree: UrlTree = router.parseUrl('403');
  const userDataService = inject(UserDataService);
  return userDataService.getCurrent()
    .pipe(
      map(user => {
        let authorities = user?.authorities?.map(e => e.authority);
        console.log(authorities);
        let userTypeU: boolean = authorities?.filter(e => e.toLowerCase() == 'u34').length > 0;
        if (userTypeU) {
          return true;
        } else {
          return new RedirectCommand(urlTree, {skipLocationChange: false});
        }
      })
    );
};
